import {ILocale} from 'data/country';

/**
 * 타임존 타입
 * @public
 */
export type ITimeZone =
  | 'America/New_York'
  | 'Asia/Seoul'
  | 'Asia/Shanghai'
  | 'Asia/Tashkent'
  | 'Asia/Ho_Chi_Minh'
  | 'Asia/Bangkok'
  | 'Europe/Moscow';

/**
 * 타임존 리스트 객체
 * @public
 */
export const timeZoneList = {
  us: 'America/New_York',
  ko: 'Asia/Seoul',
  ch: 'Asia/Shanghai',
  uz: 'Asia/Tashkent',
  vi: 'Asia/Ho_Chi_Minh',
  th: 'Asia/Bangkok',
  ru: 'Europe/Moscow',
};

/**
 * 타임존을 로케일로 변환
 * @param timeZone - 타임존
 * @returns 로케일
 * @public
 */
export const timeZoneToLocale = (timeZone: ITimeZone): ILocale => {
  switch (timeZone) {
    case 'America/New_York':
      return 'en-US';
    case 'Asia/Seoul':
      return 'ko-KR';
    case 'Asia/Shanghai':
      return 'zh-CN';
    case 'Asia/Tashkent':
      return 'uz-UZ';
    case 'Asia/Ho_Chi_Minh':
      return 'vi-VN';
    case 'Asia/Bangkok':
      return 'th-TH';
    case 'Europe/Moscow':
      return 'ru-RU';
    default:
      return 'ko-KR';
  }
};

/**
 * 로케일을 타임존으로 변환
 * @param locale - 로케일
 * @returns 타임존
 * @public
 */
export const localeToTimeZone = (locale: ILocale): ITimeZone => {
  switch (locale) {
    case 'en-US':
      return 'America/New_York';
    case 'ko-KR':
      return 'Asia/Seoul';
    case 'zh-CN':
      return 'Asia/Shanghai';
    case 'uz-UZ':
      return 'Asia/Tashkent';
    case 'vi-VN':
      return 'Asia/Ho_Chi_Minh';
    case 'th-TH':
      return 'Asia/Bangkok';
    case 'ru-RU':
      return 'Europe/Moscow';
    default:
      return 'Asia/Seoul';
  }
};
